exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audio-funny-img{object-fit:cover;height:240px;width:240px;margin:40px 40px 0;display:flex;align-items:center}.audio-controls-funny{float:left;z-index:1;width:240px;margin:0 0 0 40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ee3fb82","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/previews/SingleFunnyVoice.vue
// module id = 402
// module chunks = 1